<template>
  <div class="page">
    <navigator-menu :parentMsg="project_id"></navigator-menu>
    <el-card class="download-body">
      <span style="font-weight: bold; font-size: 25px;">Download Data</span>
      <el-divider />
      <span style="font-weight: bold; font-size: 20px; margin-left:30px;">You can choose between CSV and JSON download formats.</span>
      <ul>
        <li>Download annotation data as CSV file</li>
      </ul>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-button class="ml-3" type="success" style="width:200px" @click="downloadData('csv',$event)">
        <el-icon><Document /></el-icon>
            Download CSV file
        </el-button>

      <ul>
        <li>Download annotation data as JSON file</li>
      </ul>

        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-button class="ml-3" type="success" style="width:200px" @click="downloadData('dict',$event)">
        <el-icon><Document /></el-icon>
            Download JSON file
        </el-button>
      <ul>
        <li>Show as triple in knowledge graph</li>
      </ul>

        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-button class="ml-3" type="success" style="width:200px" @click="downloadData('kg',$event)">
        <el-icon><Document /></el-icon>
          Show as triple
        </el-button>
    </el-card>
    <!-- <el-backtop class="wow bounceInRight"/> -->
  </div>
</template>

<script>
import NavigatorMenu from "./ProNavigation";
// import NavigatorMenuMobile from "../components/NavigatorMenuMobile";
import WOW from "wow.js";
import axios from 'axios';
export default {
  name: "Download",
  components: {
  //   AdvSearch,
  //   NavigatorMenuMobile,
    NavigatorMenu,
  //   Edit,
  //   Swiper
  },
  data(){
    return{
      // fileList:[],
      searchWord: '',
      csrfToken:'',
      user_id:-1,
      project_id: this.$route.params.project_id,
      Search: require("@element-plus/icons/lib/Search"),
      searchStyle: 'font-size:23px; height: 10.5vh; width: 70vw; border-radius: 35px;overflow:hidden;',
    }
  },
  created() {
    console.log(this.$route.params.project_id)
    // 生成csrftoken
    var strcookie = document.cookie;//获取cookie字符串
    var arrcookie = strcookie.split("; ");//分割
    //遍历匹配
    for ( var i = 0; i < arrcookie.length; i++) {
      var arr = arrcookie[i].split("=");
      if (arr[0] == "csrftoken"){
        this.csrfToken = arr[1];
      }
    }
    this.getUser()
  },
  mounted() {

    // this.suggestions = this.loadAll();
    // var swiper = new Swiper(".swiper-container", {
    //   effect: "coverflow",
    //   grabCursor: true,
    //   centeredSlides: true,
    //   slidesPerView: "auto",
    //   coverflowEffect: {
    //     rotate: 0, //把旋转角度改为0度
    //     stretch: 0,
    //     depth: 100,
    //     modifier: 1,
    //     slideShadows: true,
    //   },
    //   loop: true,
    // });
    const wow = new WOW({
      boxClass: "wow", // animated element css class (default is wow)
      animateClass: "animated", // animation css class (default is animated)
      offset: 0, // distance to the element when triggering the animation (default is 0)
      mobile: true, // trigger animations on mobile devices (default is true)
      live: true, // act on asynchronously loaded content (default is true)
      callback: function (box) {
        // the callback is fired every time an animation is started
        // the argument that is passed in is the DOM node being animated
      },
      scrollContainer: null, // optional scroll container selector, otherwise use window,
      resetAnimation: true, // reset animation on end (default is true)
    });
    console.log(wow)
    wow.init();
    // this.echartinit();
  },
  methods: {
    getUser(){
        // 获取当前用户
        axios({
          method: 'get',
          url: '/api/user',
          headers:{
            'X-CSRFToken': this.csrfToken,
          },
        }).then(response => {
          if (response.status == 200) {
            console.log(response)
            this.user_id = response.data.user_id
            console.log(this.user_id)
          }
        }).catch(error=>{
          console.log('error')
          console.log(error)
        })
      },
    downloadData(dataType,evt) {
      let target = evt.target;
      if(target.nodeName == "SPAN"){
          target = evt.target.parentNode;
      }
      target.blur();
      axios({
        method: 'get',
        responseType: "blob",
        url: '/api/api/projects/download/' + this.project_id + '/'+this.user_id+'/' + dataType,
        headers:{
          'X-CSRFToken': this.csrfToken,
        },
      }).then(response => {
        console.log('response:')
        console.log(response)
        if (response.status == 200) {
          const blob = new Blob([response.data]);
          if (dataType === 'dict'){dataType = 'json'}
          const filename = "filename=" + '标注数据.' + dataType;
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob);
          console.log(href)
          downloadElement.href = href;
          downloadElement.download = decodeURIComponent(filename.split("filename=")[1]);
          document.body.appendChild(downloadElement);
          downloadElement.click();
          document.body.removeChild(downloadElement);
          window.URL.revokeObjectURL(href);
          console.log("Download Success")
          window.alert('Download Success')
        } else {
          console.log(response.msg)
          this.$message({
            message: '请检查网络情况',
            type: 'warning'
          })
        }
      })
    },

  }
}
</script>

<style>
.page {
  padding: 0;
  margin: -8px;
  height: 100%;
  width: 100%;
  position:fixed;
  background-image: url("../assets/images/weiminghu.jpeg");
  background-size:cover;
}
.download-body{
  /* margin-left: 300px; */
  left: 350px;
  top: 15vh;
  position: absolute;
  height: 110%;
  width: 75%;
  background-color: rgba(255, 255, 255, 0.7);
  /* border-color: blueviolet;
  background-color: rgba(255, 255, 255, 0.7);; */
}
</style>